module.exports = __webpack_public_path__ + "static/media/revista-42.01e1f6b4.png";